import React, { useState, useEffect } from "react";

import { Typography, Grid, Box, Divider } from "@mui/material";
const Headings = (props) => {
  return (
    <>
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          fontStyle: "Regular",
          fontSize: "20px",

          verticalAlign: "Top",
          color: "white.main",
          textAlign: { md: "start", xs: "center" },
        }}
      >
        {props.data}
      </Typography>
    </>
  );
};

export default Headings;
